function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import BadgeComponent from "components/core/badge/badge-component";
import Colors from "styles/colors";
import { generateOnKeyDownHandler } from "/client/services/accessibility/accessibility-service";
import Arrow from "static/svg/docs/arrow-up.svg";
import { TAB_CLICKED } from "/constants/bigbrain-event-types";
import MondayMarkupLanguageComponent from "client/components/system/monday-markup-language/monday-markup-language-component";
import ProgressBarComponent from "../../progressbar/progressbar-component";
import { StyledVerticalTimerTabComponent } from "./vertical-timer-tab-desktop-component.scss";
const VERTICAL_TAB_BUTTON_DIV_CLASS_NAME = "vertical-timer-tab-desktop-title-button";
class VerticalTimerTabComponent extends PureComponent {
    render() {
        const _this_props = this.props, { title, tabTitleRenderer, tabContentRenderer, content, badgeText, fontColor, selectedFontColor, titleFontWeight, fontSize, selectedFontSize, lineHeight, isSelected, forceProgressbarDone, duration, showArrow, progressbarColor, arrowSize, timerEnabled } = _this_props, rest = _object_without_properties(_this_props, [
            "title",
            "tabTitleRenderer",
            "tabContentRenderer",
            "content",
            "badgeText",
            "fontColor",
            "selectedFontColor",
            "titleFontWeight",
            "fontSize",
            "selectedFontSize",
            "lineHeight",
            "isSelected",
            "forceProgressbarDone",
            "duration",
            "showArrow",
            "progressbarColor",
            "arrowSize",
            "timerEnabled"
        ]);
        const color = isSelected ? Colors[selectedFontColor] : Colors[fontColor];
        return /*#__PURE__*/ _jsxs(StyledVerticalTimerTabComponent, {
            tabIndex: 0,
            role: "button",
            className: classnames("vertical-timer-tab-desktop-container", {
                "vertical-timer-tab-desktop-container-selected": isSelected
            }),
            onClick: this.onTabClicked,
            onKeyDown: this.onKeyDown,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: classnames(VERTICAL_TAB_BUTTON_DIV_CLASS_NAME, {
                        "vertical-timer-tab-desktop-title-button-selected": isSelected
                    }),
                    style: {
                        fontSize: isSelected ? selectedFontSize : fontSize
                    },
                    children: [
                        tabTitleRenderer ? tabTitleRenderer(title, _object_spread_props(_object_spread({}, rest), {
                            isSelected
                        })) : /*#__PURE__*/ _jsx(MondayMarkupLanguageComponent, {
                            tagName: "span",
                            style: {
                                color,
                                fontWeight: titleFontWeight,
                                lineHeight
                            },
                            text: title
                        }),
                        badgeText && /*#__PURE__*/ _jsx("div", {
                            className: "vertical-timer-tab-title-badge-margin",
                            children: /*#__PURE__*/ _jsx(BadgeComponent, {
                                badgeText: badgeText
                            })
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "vertical-timer-tab-arrow-wrapper",
                            children: showArrow && /*#__PURE__*/ _jsx(Arrow, {
                                className: classnames("vertical-timer-tab-arrow", {
                                    selected: isSelected
                                }),
                                style: {
                                    color,
                                    width: arrowSize
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: classnames("vertical-timer-tab-desktop-progress-container"),
                    children: this.shouldShowProgressbar() && /*#__PURE__*/ _jsx(ProgressBarComponent, {
                        duration: duration,
                        forceProgressbarDone: forceProgressbarDone || !timerEnabled,
                        progressbarColor: progressbarColor,
                        enabled: isSelected
                    })
                }),
                (content || tabContentRenderer) && /*#__PURE__*/ _jsx("div", {
                    className: classnames("vertical-timer-tab-desktop-content-container", {
                        "vertical-timer-tab-desktop-content-container-selected": isSelected
                    }),
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "vertical-timer-tab-desktop-content",
                        children: tabContentRenderer ? tabContentRenderer(content, _object_spread({}, rest)) : /*#__PURE__*/ _jsx(MondayMarkupLanguageComponent, {
                            text: content
                        })
                    })
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "handleTitleClick", ()=>{
            const { setSelectedTab, index, title, getTabIdentifier, isSelected } = this.props;
            const identifier = getTabIdentifier ? getTabIdentifier(this.props) : title;
            BigBrain("track", TAB_CLICKED, {
                kind: identifier,
                info1: index,
                info2: isSelected
            });
            setSelectedTab(index);
        });
        _define_property(this, "onTabClicked", (e)=>{
            this.blurTab(e);
            this.handleTitleClick();
        });
        _define_property(this, "blurTab", (e)=>{
            var _e_target_closest, _e_target;
            e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_closest = _e_target.closest(`.${VERTICAL_TAB_BUTTON_DIV_CLASS_NAME}`)) === null || _e_target_closest === void 0 ? void 0 : _e_target_closest.blur();
        });
        _define_property(this, "shouldShowProgressbar", ()=>{
            const { isSelected, timerEnabled, alwaysShowProgressbar } = this.props;
            return alwaysShowProgressbar || timerEnabled && isSelected;
        });
        this.onKeyDown = generateOnKeyDownHandler(this.handleTitleClick);
    }
}
export { VerticalTimerTabComponent as default };
